"use client";
import React from "react";
import { Box, Button, Heading, Text, Stack } from "@chakra-ui/react";
import { scrollToElement } from "@/utils/scrollToElement";
import { FiArrowRight } from "@onemind-services-llc/react-icons-ng/fi";
import HeroImg from "public/home/heroBg.webp";
import PageLayout from "@/layouts/pageLayout";
import { useSectionHeadingVariant } from "@/theme/components/useSectionHeading";
import { HERO_CONSTANTS } from "./constants";
import { BUTTON_VARIANTS } from "@/theme/components/button";
import NavigationCards from "./navigationCards";

const HeroComp = () => {
  const { title, desc, btnText } = HERO_CONSTANTS;
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box>
      <Box
        backgroundImage={HeroImg.src}
        backgroundPosition={"center"}
        backgroundSize={"cover"}
        color={"white"}
        py={{ base: 8, sm: 16, md: 24 }}
        h={{ base: "440px", md: "550px" }}
      >
        <PageLayout>
          <Stack spacing={8} width={{ base: "100%", md: "50%", lg: "40%" }}>
            <Heading as="h1" variant={HeadingVariant} fontSize={"48px"}>
              {title}
            </Heading>
            <Text style={{ fontSize: "24px", lineHeight: "30px", fontWeight: 300 }}>
              {desc}
            </Text>
            <Button
              onClick={() => scrollToElement("contact-us", 120)}
              variant={BUTTON_VARIANTS.OUTLINE}
              rightIcon={<FiArrowRight />}
              w={"fit-content"}
            >
              {btnText}
            </Button>
          </Stack>
        </PageLayout>
      </Box>
      <PageLayout>
        <Box mt={{ base: "-20vw", sm: "-15vw", md: "-12vw", lg: "-10vw" }}>
          <NavigationCards />
        </Box>
      </PageLayout>
    </Box>
  );
};

export default HeroComp;
